/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Balance_Short_CreditInputs */

const en_balance_short_credit = /** @type {(inputs: Balance_Short_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount} credit`)
};

const he_balance_short_credit = /** @type {(inputs: Balance_Short_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount} זכות`)
};

/**
* | output |
* | --- |
* | "₪{amount} credit" |
*
* @param {Balance_Short_CreditInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const balance_short_credit = /** @type {((inputs: Balance_Short_CreditInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Balance_Short_CreditInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_balance_short_credit(inputs)
	return he_balance_short_credit(inputs)
});